import { FileData } from '../../../shared/interfaces/file';

export function getDefaultFileData(fileData: FileData[] | FileData | null) {
  if (fileData) {
    if (Array.isArray(fileData)) {
      return fileData;
    }

    return [fileData];
  }

  return [];
}

export function getFileNames(fileData: FileData[] | FileData | null): string[] {
  if (fileData) {
    if (Array.isArray(fileData)) {
      return fileData.map(file => file.name);
    }

    return [fileData?.name || 'Click To Change'];
  }

  return [];
}

export function getFileName(names: string[]) {
  let displayName = '';

  if (names.length) {
    [displayName] = names;

    if (names.length > 1) {
      displayName = displayName.concat(` + ${names.length - 1}`);
    }
  }

  return displayName;
}
